export default "__VITE_ASSET__Ckerg5qY__"